module.exports = __webpack_public_path__ + "static/user-story_asth-553c6d749af6456813a812d4b82e5de0.png";